import React, { useEffect, useState } from "react";
import InstructionModal from "../liveTest/instructionModal";
import checkAuth from "../../common/CheckAuth";
import ZoomModal from "../liveTest/zoomModal";
import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  Select,
  Typography,
} from "@mui/material";
import QuestionNumberComponent from "./QuestionNumbersComponent";
import { useDispatch, useSelector } from "react-redux";
import { handleEncodeJson } from "../../utils/encodeDecodeJson";
import { DecryptObjectFunction } from "../../utils/cryptoFunction";
import { useNavigate, useSearchParams } from "react-router-dom";
import sampleTestActions from "../../Redux/sampleTest/actions";
import Cookies from "js-cookie";
import SecondaryButton from "../../common/secondaryButton";
import PrimaryButton from "../../common/primaryButton";
import examActions from "../../Redux/exam/actions";
import CalculatorComponent from "../liveTest/CalculatorComponent";
import commonActions from "../../Redux/common/actions";
import { BsArrowsFullscreen } from "react-icons/bs";
import { GoPaperclip } from "react-icons/go";
import logImage from "../../assets/images/log.png";
import useFetchCandidateTokenDetails from "../../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../../utils/auditLog";
import NotificationModal from "../../common/notificationModal";

export default function Index() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { instructions, heartBeat } = useSelector((state) => state.examReducer);
  const { sampleQuestionAnsAnswers } = useSelector(
    (state) => state.sampleTestReducer
  );

  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  const [markedValue, setMarkedValue] = useState(0);

  const [selectedValue, setSelectedValue] = useState(null);
  const [decryptedParams, setDecryptedParams] = useState({});
  const [nextQuestion, setNextQuestion] = useState([]);
  const [nextQsInFilter, setNextQsInFilter] = useState(null);
  const [selectedLanguage, setSelectedlanguage] = useState(null);
  const startTime = candidateTokenDetails?.configuration?.startTime;

  const [zoomLevel, setZoomLevel] = useState(100);

  const [currentStatus, setCurrentStatus] = useState(null);
  const [showExamStartedNotification, setShowExamStartedNotification] =
    useState(false);
  const [value, setValue] = useState(1);

  const [currentQuestionStatus, setCurrentQuestionStatus] = useState(null);
  const [updatedQuestionsList, setUpdatedQuestionsList] = useState(() => {
    const storedQuestionsList = localStorage.getItem("updatedQuestionsList");
    return storedQuestionsList
      ? JSON.parse(storedQuestionsList)
      : sampleQuestionAnsAnswers?.questionsList || {};
  });
  const [visitedQuestions, setVisitedQuestions] = useState(new Set());
  const isMultiday =
    candidateTokenDetails?.configuration?.startExamBetweenSpecifiedTime;
    useEffect(() => {
    if (!checkAuth(navigate)) return;
  }, []);
  useEffect(() => {
    const storedQuestionsList = localStorage.getItem("updatedQuestionsList");
    if (storedQuestionsList) {
      setUpdatedQuestionsList(JSON.parse(storedQuestionsList));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "updatedQuestionsList",
      JSON.stringify(updatedQuestionsList)
    );
  }, [updatedQuestionsList]);

  const questionLength = sampleQuestionAnsAnswers?.questionsList
    ? Object.keys(sampleQuestionAnsAnswers.questionsList).length
    : 0;
  const encryptedParams = searchParams.get("qNo");
  const imageSize = decryptedParams?.img;
  const language = decryptedParams?.lang;
  const currentSrNo = decryptedParams?.SrNo;

  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  const handleInstruction = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: null, method: "I", data: null },
    });
  };

  const filteredInstructions = instructions?.instructions?.filter(
    (instruction) => instruction.language === selectedLanguage
  );

  const handleZoomChange = (event) => {
    setZoomLevel(event.target.value);
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected in Sample Test Zoom",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  const handleZoom = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: null, method: "Z", data: null },
    });
    auditLog({
      data: { zoomModalOpened: true },
      dispatch,
      heartBeat,
    });
  };

  useEffect(() => {
    if (updatedQuestionsList) {
      const arr = Object.values(updatedQuestionsList);
      setSelectedValue(arr[parseInt(currentSrNo) - 1]?.selectedAnswer);
    }
  }, [updatedQuestionsList, currentSrNo]);

  useEffect(() => {
    if (decryptedParams) {
      async function fetchData() {
        if (
          decryptedParams &&
          currentSrNo &&
          !sampleQuestionAnsAnswers?.questionData?.srNo
        ) {
          let encodedData, queryParams, encryptedParans;
          queryParams = {
            SrNo: currentSrNo,
            lang: language,
            img: imageSize,
          };
          let formData = {
            imageSize: `${imageSize}`,
            action:
              currentQuestionStatus === "SKIPPED"
                ? "skip"
                : currentQuestionStatus === "MARKED"
                ? "mark"
                : "next",
            currentSrNo: currentSrNo,
            nextSrNo: currentSrNo,
            selectedAnswer: 0,
            language: `${language}`,
          };

          encodedData = await handleEncodeJson({ encodeJSON: formData });
          dispatch({
            type: sampleTestActions.GET_SAMPLE_SUBMIT_ANSWER,
            payload: {
              data: encodedData,
              navigate: navigate,
              queryParams: queryParams,
            },
          });
        }
      }
      fetchData();
    }
  }, [
    currentSrNo,
    language,
    imageSize,
    sampleQuestionAnsAnswers?.questionData?.srNo,
    decryptedParams,
    updatedQuestionsList,
  ]);

  const handleChange = async (e) => {
    const formData = {
      imageSize: `${imageSize}`,
      action:
        currentStatus === "answered_and_marked" ||
        (currentStatus === "marked" && e.target.value) ||
        sampleQuestionAnsAnswers?.questionData?.selectedAnswer
          ? "mark"
          : "next",
      currentSrNo: updatedQuestionsList[currentSrNo]?.srNo || currentSrNo,
      nextSrNo: updatedQuestionsList[currentSrNo]?.srNo || currentSrNo,
      selectedAnswer:
        parseInt(e.target.value) ||
        sampleQuestionAnsAnswers?.questionData?.selectedAnswer,
      language: `${language}`,
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    const queryParams = {
      SrNo: updatedQuestionsList[currentSrNo]?.srNo || currentSrNo,
      lang: `${language}`,
      img: `${imageSize}`,
    };

    let newUpdatedQuestionsList = { ...updatedQuestionsList };
    if (e.target.value) {
      newUpdatedQuestionsList[currentSrNo] = {
        ...newUpdatedQuestionsList[currentSrNo],
        status:
          currentStatus === "answered_and_marked" ||
          (currentStatus === "marked" && e.target.value) ||
          sampleQuestionAnsAnswers?.questionData?.selectedAnswer
            ? "ANSWERED_AND_MARKED"
            : "ANSWERED",
        selectedAnswer: e.target.value,
      };
      handleAuditLog(
        e.target.value,
        currentStatus === "answered_and_marked" ||
          (currentStatus === "marked" && e.target.value) ||
          sampleQuestionAnsAnswers?.questionData?.selectedAnswer
          ? "mark"
          : "next",
        true
      );
    }
    setUpdatedQuestionsList(newUpdatedQuestionsList);
    dispatch({
      type: sampleTestActions.GET_SAMPLE_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        navigate: navigate,
        queryParams: queryParams,
        handleSelectedValue: setSelectedValue,
        action:
          currentStatus === "answered_and_marked" ||
          (currentStatus === "marked" && e.target.value) ||
          sampleQuestionAnsAnswers?.questionData?.selectedAnswer
            ? "mark"
            : "next",
        updatedQuestionsList: newUpdatedQuestionsList,
        radio: true,
      },
    });
    setSelectedValue(e.target.value);
  };

  useEffect(() => {
    dispatch({ type: examActions.GET_INSTRUCTIONS });
  }, []);

  useEffect(() => {
    let nextqs =
      nextQuestion[
        nextQuestion.findIndex(
          (obj) => parseInt(obj.question_number) === currentSrNo
        ) + 1
      ]?.question_number;
    setNextQsInFilter(nextqs);
  }, [
    candidateTokenDetails,
    sampleQuestionAnsAnswers,
    currentSrNo,
    language,
    imageSize,
    sampleQuestionAnsAnswers?.questionData?.srNo,
    decryptedParams,
  ]);

  const handleNext = async (action, response) => {
    if (action == "mark" || currentStatus == "answered_and_marked") {
      setMarkedValue(false);
    }
    let qNo = 1;
    if (currentSrNo === questionLength) {
      const obj = sampleQuestionAnsAnswers?.questionsList;
      const arr = Object.entries(obj).map(([key, val]) => ({
        qNo: key,
        ...val,
      }));
      const filtered = arr.filter(
        (val) =>
          val?.status !== "UNANSWERED" &&
          val?.status !== "MARKED" &&
          val?.status !== "ANSWERED"
      );

      if (filtered.length > 0) {
        qNo = filtered[0]["qNo"];
      } else {
        const unanswered = arr.filter((val) => val?.status === "UNANSWERED");
        if (unanswered.length > 0) {
          qNo = unanswered[0]["qNo"];
        } else {
          const marked = arr.filter((val) => val?.status === "MARKED");
          if (marked.length > 0) {
            qNo = marked[0]["qNo"];
          } else {
            qNo = 1;
          }
        }
      }
    }
    const formData = {
      imageSize: `${imageSize}`,
      action: `${action}`,
      currentSrNo: updatedQuestionsList[currentSrNo]?.srNo || currentSrNo,
      nextSrNo:
        currentSrNo === questionLength &&
        action === "next" &&
        response != "previous"
          ? parseInt(qNo)
          : currentSrNo === questionLength && action === "mark"
          ? parseInt(currentSrNo)
          : currentSrNo === questionLength && response === "clearresponse"
          ? parseInt(currentSrNo)
          : response === "previous" && action === "next"
          ? parseInt(currentSrNo) - 1
          : response === "clearresponse" && action === "save"
          ? parseInt(currentSrNo)
          : action === "next" || action === "skip"
          ? parseInt(currentSrNo) + 1
          : action === "mark"
          ? parseInt(currentSrNo)
          : parseInt(currentSrNo),
      selectedAnswer:
        response === "clearresponse"
          ? 0
          : parseInt(selectedValue) ||
            sampleQuestionAnsAnswers?.questionData?.selectedAnswer,
      language: `${language}`,
    };

    let newUpdatedQuestionsList = { ...updatedQuestionsList };
    if (
      action === "next" ||
      action === "skip" ||
      action === "mark" ||
      action === "save"
    ) {
      newUpdatedQuestionsList[currentSrNo] = {
        ...newUpdatedQuestionsList[currentSrNo],
        status:
          response === "clearresponse"
            ? "UNANSWERED"
            : action === "next" && response === "previous"
            ? `${currentStatus.toUpperCase()}`
            : currentStatus === "answered_and_marked" &&
              action === "mark" &&
              markedValue &&
              selectedValue
            ? "ANSWERED"
            : currentStatus === "answered_and_marked" &&
              markedValue &&
              action === "next" &&
              selectedValue
            ? "ANSWERED_AND_MARKED"
            : action === "next" && markedValue && selectedValue
            ? "ANSWERED_AND_MARKED"
            : action === "next" &&
              currentStatus === "answered_and_marked" &&
              markedValue &&
              selectedValue
            ? "ANSWERED_AND_MARKED"
            : action === "next" && currentStatus === "marked" && markedValue
            ? "MARKED"
            : action === "mark" && selectedValue
            ? "ANSWERED_AND_MARKED"
            : action === "mark" && markedValue
            ? "UNANSWERED"
            : action === "next" && !selectedValue
            ? "UNANSWERED"
            : action === "next" && selectedValue
            ? "ANSWERED"
            : action === "skip"
            ? "SKIPPED"
            : "MARKED",
        selectedAnswer: response === "clearresponse" ? 0 : selectedValue,
      };
    }

    const nextQuestionIndex = currentSrNo + 1;
    if (
      action === "next" &&
      newUpdatedQuestionsList[nextQuestionIndex] &&
      newUpdatedQuestionsList[nextQuestionIndex].status === "NOT_VIEWED"
    ) {
      newUpdatedQuestionsList[nextQuestionIndex] = {
        ...newUpdatedQuestionsList[nextQuestionIndex],
        status: "UNANSWERED",
      };
    }

    const previoustQuestionIndex = currentSrNo - 1;
    if (
      response === "previous" &&
      newUpdatedQuestionsList[previoustQuestionIndex] &&
      newUpdatedQuestionsList[previoustQuestionIndex].status === "NOT_VIEWED"
    ) {
      newUpdatedQuestionsList[previoustQuestionIndex] = {
        ...newUpdatedQuestionsList[previoustQuestionIndex],
        status: "UNANSWERED",
      };
    }

    const newVisited = new Set([
      ...visitedQuestions,
      String(
        currentSrNo === questionLength
          ? questionLength
          : response === "clearresponse" && action === "save"
          ? null
          : action === "mark"
          ? currentSrNo
          : action === "next" && response === "previous"
          ? null
          : parseInt(currentSrNo) + 1
      ),
    ]);

    setVisitedQuestions(newVisited);
    sessionStorage.setItem(
      "visitedQuestions",
      JSON.stringify([...newVisited, "1"])
    );
    setUpdatedQuestionsList(newUpdatedQuestionsList);
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    const queryParams = {
      SrNo: formData.nextSrNo,
      lang: formData.language,
      img: formData.imageSize,
    };

    dispatch({
      type: sampleTestActions.GET_SAMPLE_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        navigate: navigate,
        queryParams: queryParams,
        handleSelectedValue: setSelectedValue,
        action: action,
        updatedQuestionsList: newUpdatedQuestionsList,
        markAction: action === "mark" ? true : false,
      },
    });
  };

  useEffect(() => {
    const storedVisited = sessionStorage.getItem("visitedQuestions");
    if (storedVisited) {
      setVisitedQuestions(new Set(JSON.parse(storedVisited)));
    }
    if (currentSrNo) {
      setVisitedQuestions((prev) => new Set([...prev, currentSrNo.toString()]));
      sessionStorage.setItem(
        "visitedQuestions",
        JSON.stringify([
          ...new Set([...visitedQuestions, currentSrNo.toString()]),
        ])
      );
    }
  }, [currentSrNo]);

  useEffect(() => {
    if (
      sampleQuestionAnsAnswers &&
      sampleQuestionAnsAnswers.questionsList &&
      currentSrNo
    ) {
      function getQuestionStatus(data, currentSrNo) {
        const questionData = data[currentSrNo];
        return questionData ? questionData?.status : null;
      }
      const currentQuestionStatus = getQuestionStatus(
        sampleQuestionAnsAnswers?.questionsList,
        currentSrNo
      );
      setCurrentQuestionStatus(currentQuestionStatus);
    }
  }, [
    sampleQuestionAnsAnswers,
    currentSrNo,
    decryptedParams,
    currentSrNo,
    language,
    imageSize,
    sampleQuestionAnsAnswers?.questionData?.srNo,
  ]);

  useEffect(() => {
    dispatch({
      type: examActions.GET_PROJECT_DETAILS,
      payload: {
        data: {
          project: `${Cookies.get("test_engine_project")}`,
        },
      },
    });
  }, []);

  const handleAuditLog = (selectedValue, action, radio) => {
    const registrationNumber = candidateTokenDetails?.user?.id || "";
    const rollNumber = candidateTokenDetails?.user?.rollNo || "";
    const capitalizedAction = action
      ? action.charAt(0).toUpperCase() + action.slice(1)
      : "";

    const data = {
      auditLog: [
        {
          RegistrationNumber: registrationNumber,
          RollNumber: rollNumber,
          Activity:
            action === "clear response"
              ? `User selected in Sample Test reset answer for question no ${currentSrNo}`
              : currentStatus === "answered" && action === "mark"
              ? `User selected in Sample Test Answered and Mark for Review`
              : action === "next"
              ? `User selected in Sample Test ${capitalizedAction} & viewed Question No ${
                  parseInt(currentSrNo) + 1
                }`
              : action === "previous"
              ? `User selected in Sample Test ${capitalizedAction} & viewed Question No ${
                  parseInt(currentSrNo) - 1
                }`
              : `User selected in Sample Test ${capitalizedAction}`,
          IPaddress: "",
          Timestamp: `${heartBeat?.data}`,
        },
      ],
    };

    const selectedData = {
      auditLog: [
        {
          RegistrationNumber: registrationNumber,
          RollNumber: rollNumber,
          Activity:
            (action === "mark" && selectedValue && radio) || selectedValue
              ? `User selected in Sample Test Option ${selectedValue} for Question No ${currentSrNo}`
              : action === "mark" && !radio
              ? `User selected in Sample Test Mark for Review for Question No ${currentSrNo}`
              : null,
          IPaddress: "",
          // Timestamp: `${heartBeat?.data}`,
          radio: radio,
        },
      ],
    };

    if (selectedValue) {
      dispatch({
        type: examActions.AUDIT_LOG,
        payload: { data: selectedData },
      });
    } else {
      dispatch({
        type: examActions.AUDIT_LOG,
        payload: { data },
      });
    }
  };

  useEffect(() => {
    if (updatedQuestionsList && currentSrNo) {
      const questionData = updatedQuestionsList[currentSrNo];
      setMarkedValue(
        questionData?.status === "MARKED" ||
          questionData?.status === "ANSWERED_AND_MARKED"
          ? true
          : false
      );
      setCurrentStatus(questionData?.status?.toLowerCase());
    } else {
      setMarkedValue(null);
    }
  }, [updatedQuestionsList, currentSrNo]);

  useEffect(() => {
    if (encryptedParams) {
      let decrypted = DecryptObjectFunction(encryptedParams);
      setDecryptedParams(decrypted);
    } else {
      navigate(`/${Cookies.get("test_engine_project")}/home`);
    }
  }, [encryptedParams]);

  const handleLanguageChange = async (language, newValue) => {
    setValue(newValue);
    setSelectedlanguage(language);
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected in Sample Test Language change",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    let encodedData, queryParams, encryptedParams;
    queryParams = {
      SrNo: currentSrNo,
      lang: language,
      img: imageSize,
    };
    let formData = {
      imageSize: `${imageSize}`,
      action: "next",
      currentSrNo: currentSrNo,
      nextSrNo: currentSrNo,
      selectedAnswer: selectedValue || 1,
      language: `${language}`,
    };
    encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: sampleTestActions.GET_SAMPLE_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        navigate: navigate,
        queryParams: queryParams,
      },
    });
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const requestFullscreen = async () => {
    try {
      const element = document.documentElement;
      if (element.requestFullscreen) {
        await element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        await element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        await element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        await element.msRequestFullscreen();
      }
    } catch (error) {
      console.error("Fullscreen request failed:", error);
    }
  };

  const handleFullscreenChange = () => {
    setIsFullscreen(!!document.fullscreenElement);
    if (!document.fullscreenElement) {
      setShowWarning(true);
      requestFullscreen();
    }
  };

  useEffect(() => {
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "MSFullscreenChange",
        handleFullscreenChange
      );

      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    };
  }, []);

  useEffect(() => {
    if (heartBeat?.data > startTime && !showExamStartedNotification) {
      dispatch({
        type: commonActions.SET_SHOW_MODAL,
        payload: { show: true, type: null, method: "N", data: null },
      });
      setShowExamStartedNotification(true);
    }
  }, [heartBeat]);

  const [cachedImage, setCachedImage] = useState("");
  useEffect(() => {
    const currentImage = sampleQuestionAnsAnswers?.questionData?.question;
    if (currentImage) {
      sessionStorage.setItem("cachedQuestionImage", currentImage);
      setCachedImage(currentImage);
    } else {
      const storedImage = sessionStorage.getItem("cachedQuestionImage");
      if (storedImage) {
        setCachedImage(storedImage);
      }
    }
  }, [sampleQuestionAnsAnswers?.questionData?.question]);

  return (
    <>
      <Grid container sx={{ backgroundColor: "#fff", minHeight: "88vh" }}>
        <Grid item md={2.5} p={2} sx={{ position: "relative" }}>
          <QuestionNumberComponent
            sampleQuestionAnsAnswers={sampleQuestionAnsAnswers}
            setNextQuestion={setNextQuestion}
            candidateTokenDetails={candidateTokenDetails}
            updatedQuestionsList={updatedQuestionsList}
            setUpdatedQuestionsList={setUpdatedQuestionsList}
          />

          <Grid
            p={1}
            sx={{ position: "absolute", bottom: 0, width: "100%" }}
            pb={2}
          >
            <PrimaryButton
              width="89%"
              color="#000"
              borderRadius="138px"
              height="38px"
              onClick={() => {
                navigate(`/${Cookies.get("test_engine_project")}/home`);
                sessionStorage.setItem("visitedQuestions", JSON.stringify(""));
                localStorage.removeItem("updatedQuestionsList");
                auditLog({
                  data: {
                    RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
                    RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
                    Activity: "User selected Sample Test Home",
                    IPaddress: "",
                  },
                  dispatch,
                  heartBeat,
                });
              }}
            >
              Home
            </PrimaryButton>
          </Grid>
        </Grid>
        <Grid
          item
          md={9.4}
          sx={{ background: "rgba(240, 240, 251, 1)", borderRadius: "16px" }}
          p={2}
          mb={2}
          mt={2}
        >
          <Grid container>
            <Grid item md={8}></Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                justifyContent: "flex-end",
              }}
            >
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  cursor: "pointer",
                }}
                onClick={handleInstruction}
              >
                <InfoIcon
                  sx={{ height: "20px", width: "auto", margin: 0, padding: 0 }}
                />
                <Typography sx={{ fontSize: "14px", pt: 0.5 }}>
                  Instruction
                </Typography>
              </Box> */}

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Typography sx={{ fontSize: "14px", pt: 0.5 }}>
                  Language
                </Typography>
                <FormControl fullWidth size="small">
                  <InputLabel></InputLabel>
                  <Select
                    size="small"
                    label=""
                    onChange={(event) =>
                      handleLanguageChange(event.target.value, 0)
                    }
                    sx={{ height: "30px", width: "140px" }}
                    value={language || selectedLanguage}
                  >
                    {candidateTokenDetails?.configuration?.languages?.map(
                      (language, index) => (
                        <MenuItem
                          sx={{ textTransform: "capitalize" }}
                          key={index}
                          value={language}
                        >
                          {language.charAt(0).toUpperCase() + language.slice(1)}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          <Grid
            sx={{ display: "flex", justifyContent: "space-between" }}
            pb={1}
            pt={1}
          >
            <Box>
              <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
                Question{" "}
                {currentSrNo || sampleQuestionAnsAnswers?.questionData?.srNo} of{" "}
                {questionLength}:
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
              {/* <GoPaperclip style={{ height: "22px", width: "auto" }} />
              <Box
                component={"img"}
                src={logImage}
                alt="img"
                style={{ height: "22px", width: "auto" }}
              /> */}
              <CalculatorComponent dispatch={dispatch} heartBeat={heartBeat} />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Typography sx={{ fontSize: "14px", pt: 0.5 }}>Zoom</Typography>
                <FormControl fullWidth size="small">
                  <InputLabel></InputLabel>
                  <Select
                    size="small"
                    label=""
                    sx={{ height: "30px", width: "100px" }}
                    defaultValue={100}
                    value={zoomLevel}
                    onChange={handleZoomChange}
                  >
                    <MenuItem value={100}>100%</MenuItem>
                    <MenuItem value={200}>200%</MenuItem>
                    <MenuItem value={400}>300%</MenuItem>
                    <MenuItem value={500}>400%</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </Grid>
          <Box
            p={1}
            sx={{
              minHeight: "63vh",
              backgroundColor: "white",
              border: "1px solid #E0E0E0",
              borderRadius: "8px",
            }}
          >
            <Grid
              sx={{
                height: "200px",
                paddingRight: "8px",
                border: "1px solid black",
                borderRadius: "8px",
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#e0e0e0",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "blue",
                  borderRadius: "10px",
                  border: "2px solid #e0e0e0",
                  height: "10px",
                  paddingBottom: "12px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "darkblue",
                },
              }}
            >
              <Grid
                container
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Grid item md={11}>
                  <Box
                    component={"img"}
                    src={cachedImage}
                    alt={"question"}
                    style={{
                      width: zoomLevel == 100 ? "90%" : `${zoomLevel}%`,
                      height: "auto",
                      transition: "width 0.3s ease",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  md={1}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                  p={1}
                >
                  <BsArrowsFullscreen
                    size={20}
                    style={{ cursor: "pointer" }}
                    onClick={handleZoom}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Box pt={1}>
              <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
                Answer
              </Typography>
            </Box>
            <Box
              sx={{
                height: "200px",
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#e0e0e0",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "blue",
                  borderRadius: "10px",
                  border: "2px solid #e0e0e0",
                  height: "10px",
                  paddingBottom: "12px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "darkblue",
                },
              }}
            >
              {sampleQuestionAnsAnswers?.questionData?.options?.map((q, i) => (
                <>
                  <Box
                    style={{ display: "flex", alignItems: "center" }}
                    key={i}
                  >
                    <Radio
                      checked={String(selectedValue) === String(i + 1)}
                      onChange={(e) => handleChange(e)}
                      value={String(i + 1)}
                      name="questionOptions"
                    />
                    <img
                      src={q}
                      style={{ height: "auto", width: "90%" }}
                      alt={`option-${i}`}
                    />
                  </Box>
                  <Divider sx={{ mr: 4, p: "2px" }} />
                </>
              ))}
            </Box>
          </Box>
          <Grid
            mt={1.3}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box sx={{ display: "flex", gap: "4px" }}>
              <FormControlLabel
                sx={{ margin: 0, padding: 0, color: "rgba(63, 65, 209, 1)" }}
                control={
                  <Checkbox
                    color="success"
                    sx={{
                      margin: 0,
                      padding: 0,
                      color: "rgba(63, 65, 209, 1)",
                    }}
                    onChange={() => {
                      handleAuditLog("", "mark");
                      handleNext("mark");
                    }}
                    checked={markedValue}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "rgba(63, 65, 209, 1)",
                      pt: 0.5,
                    }}
                  >
                    Mark Review
                  </Typography>
                }
              />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <SecondaryButton
                color={"rgba(63, 65, 209, 1)"}
                border="1px solid rgba(63, 65, 209, 1)"
                onClick={() => {
                  handleNext("next", "previous");
                  handleAuditLog("", "previous");
                }}
                disabled={currentSrNo === 1}
              >
                Previous
              </SecondaryButton>
              <SecondaryButton
                color={"rgba(63, 65, 209, 1)"}
                border="1px solid rgba(63, 65, 209, 1)"
                onClick={() => {
                  handleNext("save", "clearresponse");
                  handleAuditLog("", "clear response");
                }}
                disabled={!selectedValue}
              >
                Reset Answer
              </SecondaryButton>
              <SecondaryButton
                color={"rgba(63, 65, 209, 1)"}
                border="1px solid rgba(63, 65, 209, 1)"
                onClick={() => {
                  handleNext("next");
                  handleAuditLog("", "next");
                }}
                disabled={
                  currentSrNo === questionLength ||
                  sampleQuestionAnsAnswers?.questionData?.srNo ===
                    questionLength
                }
              >
                Next
              </SecondaryButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <ZoomModal img={sampleQuestionAnsAnswers?.questionData?.question} />
      <InstructionModal
        filteredInstructions={filteredInstructions}
        value={value}
      />
      {!isMultiday && <NotificationModal />}
    </>
  );
}
